import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from '../../services/Auth';

class FinanceInvoices extends Api {
  constructor(resourceKey = 'finance/invoices/') {
    super(resourceKey);
  }

  onExportToExcel = (params) => {
    return this.buildQuery('post', { params }, 'export');
  };

  approveInvoice = (id, companyId, comment, status) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/finance/invoices/${id}/approve`,
      method: 'post',
      data: {
        company_id: companyId,
        comment,
        status,
      },
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  };

  generateInvoice = (companyId) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/finance/invoices/generate?company_id=${companyId}`,
      method: 'post',
      data: {},
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  };
}

export default FinanceInvoices;
